export default __webpack_public_path__ + "static/media/title_pc.bb2edc47.png";